import React, { useMemo, useState } from "react";
import {
  Box,
  Card,
  Container,
  Stack,
  Typography,
  Checkbox,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  TextField,
  Button,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
} from "@mui/material";
import { useEffect } from "react";
import Link from "@mui/material/Link";
import axios from "axios";
import { API } from "../../pages/backend";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import data from "../dropDown";
import Swal from "sweetalert2";
import Spinner from "../ui/Spinner";
import { useDispatch } from "react-redux";
import { loggedInUser, setUser } from "../../store/reducers/user";
import FormButton from "../ui/button/FormButton";
import InputField from "../forms/input/TextInput/InputField";
import { apiRequest } from "../../services/auth";
import { closeModal, showModal } from "../../store/reducers/modal";


const RegisterTradeTest = ({

  examType = "PUBLIC SERVICE REGISTRATION",
  serviceType,
  navigateTo,
}) => {
  const formSchema = yup.object().shape({
    firstName: yup
      .string()
      .required("First Name is required")
      .matches(/^[A-Za-z]+(-[A-Za-z]+)*$/, "First Name should not contain numbers"),
    lastName: yup
      .string()
      .required("Last Name is required")
      .matches(/^[A-Za-z]+(-[A-Za-z]+)*$/, "Last Name should not contain numbers"),
    email: yup
      .string()
      .required("Email can't be empty")
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "Invalid Email Address"
      ),
    gender: yup
      .string()
      .required("Gender is required")
      .matches(/^[a-zA-Z]*$/, "Select gender"),
    phoneNumber: yup
      .string()
      .required("Phone Number is required")
      .matches(/^[0-9]{1,11}$/, "Phone number must be 11 digits"),
    // payerId: yup.string().required("Payer ID is required"),

    password: yup
      .string()
      .required("Password is required")
      .matches(
        /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
        "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
      ),
    confirm: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required")
      .matches(
        /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
        "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
      ),
  });

  // const [occupation, setOccupation] = useState("");
  // const [tradeType, setTradeType] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { gender } = data;
  const [studentGender, setStudentGender] = useState("")
  // useform
  const {
    setValue,
    handleSubmit,
    formState: { errors },
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(formSchema),
  });



  const Register = async () => {

    const submitUrl =  `individual/register/05`
   

    let value = watch();
    console.log(value);
    const isValid = await trigger(); // Trigger validation
    // console.log(isValid)
    // Do not proceed if there are validation errors
    if (!isValid) return;

    // delete value.confirm
    try {
      setLoading(true);
      const res = await apiRequest({
        method: "post",
        url: submitUrl,
        payload: value,
        successMessage: " ",
        showError: true,
        dispatchFunct: dispatch(closeModal(<></>)),

      });
      if (res?.data?.status === "success") {
        navigate(navigateTo);
        Swal.fire({
          title: "Successful",
          text: res?.data?.data?.message,
          icon: "success",
          confirmButtonText: "Ok",
        });
        // console.log(res?.data?.response?.user)
        // console.log(res?.data?.response)
        console.log(res?.data?.data);
        dispatch(setUser(res?.data?.data));
      } else if (res?.data?.status === "failure" ) {
        Swal.fire({
          title: "Error",
          text: res?.data?.message,
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      // console.log(res?.data?.response?.user)
      // dispatch(setUser(res?.data?.response));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const location = useLocation();
  const [loginPage, setLoginPage] = useState(null);

  const isDisabled = useMemo(() => {
    const {
      firstName,
      lastName,
      gender,
      phoneNumber,
      email,
      password,
      confirm,
    } = watch();

    let bool =
      firstName &&
      lastName &&
      password &&
      confirm &&
      phoneNumber?.length === 11 &&
      password === confirm &&
      // middleName &&
      gender &&
      email; 
    
    return !bool;
  }, [watch()]);

  useEffect(() => {
    if (location.pathname === "/public/payment/register") {
      setLoginPage("/public/payment/login");
    } else if (location.pathname === "/model/payment/register") {
      setLoginPage("/model/payment/login");
    } else if (location.pathname === "/trade/test/payment/register") {
      setLoginPage("/tradetest/payment/login")
    }
  },

    [location.pathname]);

  // const tradeTypeClick = (val) => {
  //   const selectedOption = occupationDropDown[occupation].find(option => option.value === val.target.value);

  //   if (selectedOption) {
  //     setTradeType(selectedOption.value);
  //     // console.log(selectedOption.id.toString().padStart(4, '0'));
  //   }
  // };

  // const occupationDropDown = {
  //   "Artisans": [
  //     { id: "0014", value: "Tailoring & Garment Making " },
  //     { id: "0013", value: "Electrical Installation" },
  //     { id: "00012", value: "Plumbing & Pipe fitting" },
  //     { id: "00011", value: "Painting & Decoration" },
  //     { id: "00010", value: "Driver & Mechanics" },
  //     { id: "0009", value: "Blocklaying & Concrete" },
  //     { id: "0008", value: "Welding & Fabrication" },
  //     { id: "0007", value: "Panel Beating Carpentry & Joinery " },
  //     { id: "0006", value: "Leather Works" },
  //     { id: "0005", value: "Aluminum Fabrication" },
  //     { id: "0004", value: "Barbing" },
  //     { id: "0003", value: "Photography" },
  //     { id: "0002", value: "Hairdressing" },
  //     { id: "0001", value: "Catering and Hotel Management" },
  //   ],
  //   "Civil Servant": [
  //     {id: "0001", value: "M.D.A"},
  //     {id: "0002", value: "Department"},
  //   ],
  // };

  const registerConfirm = () => {
    let value = watch();
    trigger().then((isValid) => {
      if (!isValid) return;
    });
    dispatch(
      showModal({
        content: (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "24px" }}
          >
            <Typography
              style={{
                display: "flex",
                fontSize: "18px",
                fontWeight: "bold",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              Please confirm your details before proceeding
            </Typography>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                fontSize: "18px",
                fontWeight: "bold",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "5px",
              }}
            >
              <Typography>
                {" "}
                Name:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {value?.firstName} {value?.middleName} {value?.lastName}
                </span>
              </Typography>
              <Typography>
                Email:{" "}
                <span style={{ fontWeight: "bold" }}>{value?.email}</span>
              </Typography>
              <Typography>
                PhoneNumber:{" "}
                <span style={{ fontWeight: "bold" }}>{value?.phoneNumber}</span>
              </Typography>
            </div>

            <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
                justifyContent: "space-between",
              }}
            >
              <FormButton
                label={"Cancel"}
                width="medium"
                onClick={() => dispatch(closeModal(<></>))}
              />
              <FormButton
                label={loading ? <Spinner width="5%" /> : "Proceed"}
                width="medium"
                onClick={() => Register()}
                type="submit"
              />
            </Box>
          </div>
        ),
      })
    );
  };




  return (
    <div >
      <Card
        className="register-card-pubmod"
        elevation={5}
        style={{
          boxShadow: "2px 2px 5px 0px rgba(0, 0, 0, 0.5)",
          borderRadius: "10px",
          border: "2px solid #34A56F",
        }}
      >
        <Container component="div">
          <Stack style={{ textAlign: "center", paddingTop: "2rem" }}>
            <Typography variant="h5" style={{ fontWeight: "bold" }}>
              EXAM PORTAL REGISTRATION
            </Typography>
            <Typography variant="subtitle2" style={{ marginTop: "10px" }}>
              {" "}
              {examType}{" "}
            </Typography>
          </Stack>
          <div
          // style={{
          //   padding: "30px 40px",
          // }}
          >
            <form
            // onSubmit={handleSubmit(Register)}
            // onSubmit={Register}
            >
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                  <InputField
                      name="lastName"
                      label="SurName"
                      type="lastName"
                      placeholder="SurName"
                      // value={lastName}
                      onChange={(e) => {
                        setValue("lastName", e.target.value);
                      }}
                      style={{ height: "100%" }}
                    />

                    <Typography
                      sx={{
                        color: "#e53e3e",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      style={{
                        visibility: errors.firstName ? "visible" : "hidden",
                      }}
                    >
                      {errors.firstName?.message}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                  <InputField
                      name="firstName"
                      label="First Name"
                      type="firstName"
                      placeholder="First Name"
                      // value={firstName}
                      onChange={(e) => {
                        setValue("firstName", e.target.value);
                      }}
                      style={{ height: "100%" }}
                    />
                    <Typography
                      sx={{
                        color: "#e53e3e",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      style={{
                        visibility: errors.lastName ? "visible" : "hidden",
                      }}
                    >
                      {errors.lastName?.message}
                    </Typography>
                  </Grid>
                </Grid>
              </div>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#9b9494",
                        fontSize: "1rem",
                        fontWeight: "bolder",
                        marginTop: "10px"
                      }}
                      mb={1}
                    >
                      Sex
                    </Typography>
                    <TextField
                      size="normal"
                      name="gender"
                      label="Select Sex"
                      // type="sex"
                      // placeholder="Sex"
                      value={studentGender}
                      select
                      onChange={(e) => { setValue("gender", e.target.value); setStudentGender(e.target.value) }}
                      // onChange={(e) => setGender(e.target.value)}
                      style={{ width: "100%", }}
                    >
                      {gender.map((item, index) => (
                        <MenuItem key={index} value={item.value}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </TextField>
                    {/* <InputField
                      name="sex"
                      label="Sex"
                      type="sex"
                      placeholder="Select Sex"
                      // value={phone}
                      onChange={(e) => {
                        setValue("sex", e.target.value);
                      }}
                      style={{ height: "100%" }}
                    /> */}
                  </Grid>

                  <Grid item xs={6}>
                    <InputField
                      name="phoneNumber"
                      label="Phone Number"
                      type="number"
                      placeholder="Phone Number"
                      // value={phone}
                      onChange={(e) => {
                        setValue("phoneNumber", e.target.value.trim());
                      }}
                      style={{ height: "100%" }}
                    />
                    <Typography
                      sx={{
                        color: "#e53e3e",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      style={{
                        visibility: errors.phoneNumber ? "visible" : "hidden",
                      }}
                    >
                      {errors.phoneNumber?.message}e
                    </Typography>
                  </Grid>
                </Grid>
              </div>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <InputField
                    name="email"
                    label="Email"
                    type="email"
                    placeholder="Email"
                    // value={email}
                    onBlur={() => trigger("email")}
                    onChange={(e) => {
                      setValue("email", e.target.value.trim());
                    }}
                    style={{ height: "100%", }}
                  />
                  <Typography
                    sx={{
                      color: "#e53e3e",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                    style={{
                      visibility: errors.email ? "visible" : "hidden",
                    }}
                  >
                    {errors.email?.message}
                  </Typography>
                </Grid>
                {/* <Grid item xs={6}>
                    <InputField
                      name="D.O.B"
                      label="D.O.B"
                      type="D.O.B"
                      placeholder="D.O.B"
                      // value={password}
                      // password
                      // onChange={(e) => {
                      //   setValue("password", e.target.value);
                      // }}
                      style={{ height: "100%" }}
                    />
                    
                  </Grid> */}
              </Grid>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <InputField
                      name="password"
                      label="Password"
                      type="password"
                      placeholder="Password"
                      // value={password}
                      password
                      onChange={(e) => {
                        setValue("password", e.target.value.trim());
                      }}
                      style={{ height: "100%" }}
                    />
                    <Typography
                      sx={{
                        color: "#e53e3e",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      style={{
                        visibility: errors.password ? "visible" : "hidden",
                      }}
                    >
                      {errors.password?.message}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputField
                      name="confirm"
                      label=" Confirm Password"
                      type="confirm"
                      placeholder=" Confirm Password"
                      password
                      // value={confirmPassword}
                      onChange={(e) => {
                        setValue("confirm", e.target.value.trim());
                      }}
                      style={{ height: "100%" }}
                    />
                    <Typography
                      sx={{
                        color: "#e53e3e",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      style={{
                        visibility: errors.confirm ? "visible" : "hidden",
                      }}
                    >
                      {errors.confirm?.message}
                    </Typography>
                  </Grid>
                </Grid>
              </div>

              <Stack style={{ marginTop: "10px" }}>
                {/* Register Button */}
                <FormButton
                  type="button"
                  label={loading ? <Spinner width="5%" /> : "Register"}
                  width="full"
                  disabled={isDisabled}
                  onClick={registerConfirm}
                />
              </Stack>

              <Typography
                variant="body2"
                fontWeight="normal"
                marginTop="10px"
                textAlign="center"
                cursor="pointer"
                color="#807c7c"
              >
                Already signed up? {"   "}
                {"   "}
                <Link
                  href={loginPage}
                  style={{
                    textDecoration: "none",
                    color: "#34A56F",
                    fontWeight: "bold",
                  }}
                >
                  {"  "}
                  Login
                </Link>
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                marginTop="10px"
                textAlign="center"
                cursor="pointer"
                color="secondary"
              >
                <Link
                  href="https://tradetest.examsboard.lagosstate.gov.ng/"
                  style={{
                    textDecoration: "none",
                    color: "#34A56F",
                    fontWeight: "normal"
                  }}
                >
                  {"  "}
                  Back to home page
                </Link>
              </Typography>
            </form>
          </div>
          {/* <Footer /> */}
        </Container>
      </Card>
    </div>
  );
};

export default RegisterTradeTest;